window.onload = function(){
  var icChatButton = document.getElementById('icChatButton');
  icChatButton.setAttribute('title','online chat');
  // icChatButton.style.display = 'none';  // 隐藏按钮
  
  var icChat = document.getElementById('icChat');
  icChat.setAttribute('title','isChat');


  // 获取 iframe 元素
  const iframe = document.querySelector('iframe');

  // 监听 iframe 加载完成事件
  iframe.addEventListener('load', function() {
    // iframe 加载完成后执行操作
    modifyIframeContent();
  });
  function modifyIframeContent() {
    // 获取 iframe 的 document 对象
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // 查找 iframe 内的 chat-button 元素
    const chatButton = iframeDoc.querySelector('#chat-button'); // 按 ID 查找
    // 或按类名查找：iframeDoc.querySelector('.chat-button');

    if (chatButton) {
      // 直接修改样式
      chatButton.style.boxShadow = 'none';
    } else {
      console.error('未找到 chat-button 元素');
    }
  }
}
